import { subnames } from '@pages/names';

export default (state = 'results', action = {}) =>
  subnames[action.type] || state;
